var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0975 3H4.23305C3.55487 3 3.00617 3.56222 3.00617 4.24938L3 15.4938L5.4661 12.9951H9.78179H14.0975C14.7756 12.9951 15.3305 12.4328 15.3305 11.7457V4.24938C15.3305 3.56222 14.7756 3 14.0975 3ZM7.31568 8.62223H6.08263V7.37284H7.31568V8.62223ZM9.78179 8.62223H8.54873V7.37284H9.78179V8.62223ZM12.2479 8.62223H11.0148V7.37284H12.2479V8.62223Z",
    fill: "#A59696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.5dbbf32b360665427044e48c77ef1100.svg";
export { ForwardRef as ReactComponent };